module.exports = __webpack_public_path__ + "media/images/athletes/1593-adeec78d4baa7afc1b418c9035a1f878.png";